import type { Icon } from '@solar-icons/react/lib/types'
import { ChatRoundLineIcon } from '@solar-icons/react/linear/chat-round-line'
import { HistoryIcon } from '@solar-icons/react/linear/history'
import { BookmarkIcon } from '@solar-icons/react/linear/bookmark'
import { PulseIcon } from '@solar-icons/react/linear/pulse'
import { SettingsIcon } from '@solar-icons/react/linear/settings'

export interface RouteDefinition {
  path: string
  label: string
  icon: Icon
  description: string
}

/**
 * Single source of truth for navigation. The sidebar renders from this list and
 * the router registers from it, so adding a view is one entry plus one element.
 */
export const ROUTES: RouteDefinition[] = [
  {
    path: '/',
    label: 'Chat',
    icon: ChatRoundLineIcon,
    description: 'Ask questions in plain language',
  },
  {
    path: '/history',
    label: 'History',
    icon: HistoryIcon,
    description: 'Every query this browser has run',
  },
  {
    path: '/saved',
    label: 'Saved',
    icon: BookmarkIcon,
    description: 'Queries you kept for reuse',
  },
  {
    path: '/diagnostics',
    label: 'Diagnostics',
    icon: PulseIcon,
    description: 'Backend health and connectivity',
  },
  {
    path: '/settings',
    label: 'Settings',
    icon: SettingsIcon,
    description: 'Endpoint, route, and appearance',
  },
]
